<template>
    <main @click="clickedOnMain">
        <EditorHeader></EditorHeader>

        <div class="base-container">
            <Sidebar></Sidebar>

            <div class="main">
                <div id="canvas-container" class="canvas-container" ref="canvasContainer">
                    <CanvasStage></CanvasStage>

                    <Popup></Popup>

                    <ContextMenuMain></ContextMenuMain>

                    <BoxListingInputCell v-if="activeCell"></BoxListingInputCell>
                </div>
            </div>
        </div>

        <PermissionToEditModal v-if="hasUserAccess && displayPermissionToEditModal"
                               :trimName="trimName"
                               :openedBy="trimIsOpenedByUser"
                               @closeModal="closePermissionToEditModal"
        ></PermissionToEditModal>

        <ServerWillBeOffNotification></ServerWillBeOffNotification>
    </main>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import Sidebar from './sidebar/Sidebar';
    import CanvasStage from './canvas/Stage';
    import Popup from './popups/Popup';
    import EditorHeader from "./header/EditorHeader";
    import PermissionToEditModal from "../components/modals/PermissionToEditModal";
    import ServerWillBeOffNotification from "../system/server-restart/ServerWillBeOffNotification";
    import BoxListingInputCell from "./boxListing/BoxListingInputCell";
    import ContextMenuMain from "./canvas/contextMenu/ContextMenuMain";

export default {
    name: 'Main',

    components: {
        ContextMenuMain,
        BoxListingInputCell,
        ServerWillBeOffNotification,
        PermissionToEditModal,
        EditorHeader,
        Sidebar,
        CanvasStage,
        Popup,
    },

    data() {
        return {
            displayPermissionToEditModal: false,
            timerForOpenedStatus: null,
        }
    },

    computed: {
        ...mapState('trimInfo', [
            'trimName',
            'isTrimExported',
            'permissionToEdit',
            'trimIsOpenedByUser',
        ]),

        ...mapState('inputCell', [
            'activeCell',
        ]),

        ...mapGetters('authentication', [
            'hasUserAccess',
        ]),
    },

    methods: {
        ...mapMutations('editor', [
            'setCanvasStageSize',
        ]),

        ...mapActions('editor', [
            'stopDrawing',
        ]),

        ...mapActions('trims', [
            'setCurrentTrimToEditor',
            'updateOpenedTrimStatus',
        ]),

        clickedOnMain(e) {

            if (e.target.tagName !== 'CANVAS') {
                // that is out of the canvas area
                // stop the drawing

                this.stopDrawing();
            }
        },

        updateStageSize() {
            const canvasContainer = this.$refs.canvasContainer;

            const stageSize = {
                width: canvasContainer?.offsetWidth || 100,
                height: canvasContainer?.offsetHeight || 100,
            };

            this.setCanvasStageSize(stageSize);
        },

        openPermissionToEditModal() {
            this.displayPermissionToEditModal = true;
        },

        closePermissionToEditModal() {
            this.displayPermissionToEditModal = false;
        },

        checkPermissionToEdit() {
            // no need to check for the exported trim
            if (this.isTrimExported) return;

            if (this.permissionToEdit) {
                // notice to the server that user still use this trim
                this.runTimerForOpenedStatus();
            }
            else {
                this.openPermissionToEditModal();
            }
        },

        runTimerForOpenedStatus() {
            const time = 60*1000; // 60 sec

            this.timerForOpenedStatus = setTimeout(() => {
                this.updateOpenedTrimStatus(true);

                this.runTimerForOpenedStatus();
            }, time);
        },

    },

    mounted() {
        this.updateStageSize();

        this.checkPermissionToEdit();
    },

    beforeUnmount() {
        // notice to the server that the trim is available now
        clearTimeout(this.timerForOpenedStatus);
        this.updateOpenedTrimStatus(false);
    },

    async beforeRouteUpdate(to) {
        // route was changed to new trim

        // clear undo/redo history for the new trim


        // need to set a new trim as the current
        const params = to.params;
        const url = params['trimName'];
        const trimIdMatches = url.match(/[0-9]+/);
        const trimId = trimIdMatches && +trimIdMatches[0];

        if (!trimId) {
            this.$router.push({ to: '/' });

            return;
        }

        await this.setCurrentTrimToEditor(trimId);
    },

}
</script>

<style scoped>
    main {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .base-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
        font-family: Arial, sans-serif;
    }

    .main {
        display: flex;
        width: 100%;
        height: 100%;
    }

    .canvas-container {
        flex: 0 1 auto;
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
    }

</style>